export default __webpack_public_path__ + "static/media/Background_00136.e2d3828e.png";